<script>
export default {
    name : 'rightArrow'
}
</script>

<template>

<svg width="52" height="45" viewBox="0 0 52 45" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.761719 0.305176L50.5494 0.127685L51.3477 43.9109L1.56005 44.0884L0.761719 0.305176Z" fill="white" fill-opacity="0.01"/>
<path d="M20.7012 11.1938L33.2947 22.0794L21.0988 33.0537" stroke="#003675" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>